import getLangLocale from 'I18n/utils/getLangLocale';
import { useCallback, useMemo } from 'react';
import { useGetCollectionsQuery as useGetCollectionsQueryPublic, useGetRelevantPublishedIdsQuery as useGetRelevantPublishedIdsQueryPublic } from '../../../__generated__/chirp/com/hubspot/marketplace/quality/rpc/CollectionsPublicRpc.hooks';
import { useGetCollectionsQuery, useGetRelevantPublishedIdsQuery } from '../../../__generated__/chirp/com/hubspot/marketplace/quality/rpc/CollectionsRpc.hooks';
export function useRelevantCollections({
  appContext,
  offeringType
}) {
  const isPublic = appContext === 'public';
  const productType = offeringType;
  const relevantIdsQueryApp = useGetRelevantPublishedIdsQuery({
    variables: {
      productType
    },
    skip: isPublic
  });
  const relevantIdsQueryPublic = useGetRelevantPublishedIdsQueryPublic({
    variables: {
      productType
    },
    skip: !isPublic
  });
  const collectionsQueryApp = useGetCollectionsQuery({
    variables: {
      productType,
      published: true
    },
    skip: isPublic
  });
  const collectionsQueryPublic = useGetCollectionsQueryPublic({
    variables: {
      locale: getLangLocale(),
      productType,
      published: true
    },
    skip: !isPublic
  });
  const relevantIdsQuery = isPublic ? relevantIdsQueryPublic : relevantIdsQueryApp;
  const collectionsQuery = isPublic ? collectionsQueryPublic : collectionsQueryApp;
  const relevantCollectionIdsSet = useMemo(() => {
    var _relevantIdsQuery$dat, _relevantIdsQuery$dat2;
    return new Set((_relevantIdsQuery$dat = (_relevantIdsQuery$dat2 = relevantIdsQuery.data) === null || _relevantIdsQuery$dat2 === void 0 ? void 0 : _relevantIdsQuery$dat2.collectionIds) !== null && _relevantIdsQuery$dat !== void 0 ? _relevantIdsQuery$dat : []);
  }, [relevantIdsQuery.data]);
  const filteredCollections = useMemo(() => {
    var _collectionsQuery$dat;
    if (!((_collectionsQuery$dat = collectionsQuery.data) !== null && _collectionsQuery$dat !== void 0 && _collectionsQuery$dat.collections)) return [];
    return collectionsQuery.data.collections.filter(collection => relevantCollectionIdsSet.has(collection.id));
  }, [collectionsQuery.data, relevantCollectionIdsSet]);
  const getCollectionById = useCallback(id => {
    return filteredCollections.find(collection => collection.id === id);
  }, [filteredCollections]);
  const getCollectionBySlug = useCallback(slug => {
    return filteredCollections.find(collection => collection.slug === slug);
  }, [filteredCollections]);
  const getDisplayedCollections = useCallback(() => {
    return filteredCollections.filter(collection => collection.displayed !== false).sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0));
  }, [filteredCollections]);
  const getCollectionSlugs = useCallback(() => {
    return filteredCollections.map(collection => collection.slug);
  }, [filteredCollections]);
  const loading = relevantIdsQuery.loading || collectionsQuery.loading;
  const error = relevantIdsQuery.error || collectionsQuery.error;
  return {
    data: filteredCollections,
    error,
    getCollectionById,
    getCollectionBySlug,
    getCollectionSlugs,
    getDisplayedCollections,
    loading
  };
}